import React from 'react';
import NeedActionContainer from './NeedActionContainer';
import PrivatePageHOC from '../../containers/PrivatPageHOC/PrivatePageHOC';

const HelpPage = () => {
  return <NeedActionContainer />;
};

export default PrivatePageHOC(HelpPage);
